// src/components/Layout.jsx
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { useAuth } from "../context/AuthContext";

export default function Layout() {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate()
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const closeSidebar = () => setSidebarOpen(false);
  useEffect(() => {
    if (location.pathname == "/" && isAuthenticated) {
      navigate("/pages")
    }
  }
    , [location.pathname]);

    useEffect(()=>{
      if(isAuthenticated){
        login()
      }
    },[])
  return (
    <div className={`layout ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div
        className="layout-content"
        // clicking the main content should close the sidebar on mobile
        onClick={() => {
          if (sidebarOpen) closeSidebar();
        }}
      >
        {/* pass toggleSidebar & sidebarOpen via Outlet context */}
        <Outlet context={{ toggleSidebar, closeSidebar, sidebarOpen }} />
      </div>
    </div>
  );
}
